export default /* GraphQL */ `
  query stepAction($id: Int!) {
  stepAction(id:$id){
    actions{
      buttonText
      id
      sort
      title
    }
    buttonText
    dozukiId
    id
    multiStep
    subTitle
    title
    guide {
      id
      steps {
        images{
          medium
          thumbnail
        }
        lines{
          bullet
          text
        }
        stepid
        title
        video{
          encodings{
            codecs
            column
            label
            mime
            url
            width
          }
          image{
            medium
          }
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/utils/content/contentQuery.js